
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.95 8.38A1.052 1.052 0 0021 7.334V4.19a1.045 1.045 0 00-.718-.993L10.832.054a1.054 1.054 0 00-.664 0L.718 3.197A1.049 1.049 0 000 4.19v3.143a1.045 1.045 0 001.05 1.048H2.1v7.526a3.144 3.144 0 00-2.1 2.95v2.095A1.045 1.045 0 001.05 22h18.9A1.05 1.05 0 0021 20.952v-2.095a3.133 3.133 0 00-2.1-2.95V8.381h1.05zM18.9 19.906H2.1v-1.048a1.047 1.047 0 011.05-1.048h14.7a1.053 1.053 0 011.05 1.048v1.048zm-14.7-4.19V8.38h2.1v7.333H4.2zm4.2 0V8.38h4.2v7.333H8.4zm6.3 0V8.38h2.1v7.333h-2.1zM2.1 6.284v-1.34l8.4-2.794 8.4 2.794v1.34H2.1z"}})])
          )
        }
      }
    